import { createContext, useContext, useEffect, useState, type ReactNode } from 'react';
import { onAuthStateChanged, type User } from 'firebase/auth';
import { getFirebaseAuth } from './firebase.ts';

const USE_MOCK = import.meta.env.VITE_USE_MOCK === '1';

interface AuthState {
  user: User | null;
  loading: boolean;
  /** Mock mode skips real auth so the UI renders without Firebase. */
  mock: boolean;
}

const AuthContext = createContext<AuthState>({ user: null, loading: true, mock: USE_MOCK });

export function AuthProvider({ children }: { children: ReactNode }) {
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(!USE_MOCK);

  useEffect(() => {
    if (USE_MOCK) return;
    return onAuthStateChanged(getFirebaseAuth(), (u) => {
      setUser(u);
      setLoading(false);
    });
  }, []);

  return (
    <AuthContext.Provider value={{ user, loading, mock: USE_MOCK }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
